module.exports = "/static/assets/6c5d6b7c2a3958980c36b4199bc3878c.png";